import { CHART_VIEW, ChartCandle, ChartModel } from './chart-model';

export interface ChartSelection {
    index: number;
    candle: ChartCandle;
}

export function clientToSvgX(
    clientX: number, rectLeft: number, rectWidth: number
): number | null {
    if (
        !Number.isFinite(clientX)
        || !Number.isFinite(rectLeft)
        || !Number.isFinite(rectWidth)
        || rectWidth <= 0
    ) return null;
    return (clientX - rectLeft) * CHART_VIEW.width / rectWidth;
}

export function selectionAtIndex(
    model: ChartModel, requestedIndex: number
): ChartSelection | null {
    if (!model.candles.length || !Number.isFinite(requestedIndex)) return null;
    const index = Math.max(
        0,
        Math.min(model.candles.length - 1, Math.trunc(requestedIndex))
    );
    return { index, candle: model.candles[index] };
}

export function selectionAtX(
    model: ChartModel, svgX: number | null
): ChartSelection | null {
    if (
        svgX === null
        || svgX < CHART_VIEW.left
        || svgX > CHART_VIEW.right
        || !model.candles.length
    ) return null;
    const step = (
        (CHART_VIEW.right - CHART_VIEW.left) / model.candles.length
    );
    return selectionAtIndex(
        model,
        Math.floor((svgX - CHART_VIEW.left) / step)
    );
}

export function selectionByKey(
    model: ChartModel, key: string
): ChartSelection | null {
    const index = model.candles.findIndex(candle => candle.key === key);
    return index < 0 ? null : selectionAtIndex(model, index);
}
